import React, { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';

const SaleOrderScopeContext = createContext<string | undefined>(undefined);

interface SaleOrderScopeProviderProps {
	saleOrderId?: string;
	children: React.ReactNode;
}

export const SaleOrderScopeProvider = ({ saleOrderId, children }: SaleOrderScopeProviderProps): JSX.Element => {
	return <SaleOrderScopeContext.Provider value={saleOrderId}>{children}</SaleOrderScopeContext.Provider>;
};

/** Resuelve saleOrderId desde contexto (edición rápida) o desde la ruta /salesorder/:id */
export const useSaleOrderId = (): string => {
	const fromContext = useContext(SaleOrderScopeContext);
	const { id: fromParams } = useParams<{ id: string }>();
	const saleOrderId = fromContext ?? fromParams ?? '';

	return saleOrderId;
};
